module.exports = __webpack_public_path__ + "img/new-logo.1f443d93.png";